<template>
  <div>
    <!-- no-close-on-backdrop
      no-close-on-esc -->
    <b-modal
      ref="modal-rrhh-discount"
      :title="$t(getTitleModal)"
      modal-class="modal-primary"
      hide-footer
      @hidden="$emit('hideModal')"
      size="lg"
      no-close-on-backdrop
      no-close-on-esc
    >
      <!-- <div class="scroll-kanban"> -->
      <ValidationObserver ref="ref-validation-aumento-sueldo">
        <b-row>
          <b-col lg="4" md="12" sm="12">
            <ValidationProvider
              v-slot="{ errors }"
              rules="required"
              name="area_id"
            >
              <b-form-group
                label-for="area_id"
                :state="errors[0] ? false : null"
              >
                <label class="form-label"
                  >{{ $t("Area") }} <span class="text-danger">(*)</span></label
                >
                <v-select
                  id="area_id"
                  v-model="form.area_id"
                  :options="areas"
                  label="name"
                  :disabled="inputDisable"
                  :reduce="(area) => area.id"
                  placeholder="Seleccione..."
                  @input="getEmployeeByArea(null)"
                />
              </b-form-group>
            </ValidationProvider>
          </b-col>

          <!-- Employee -->
          <b-col lg="8" md="12" sm="12">
            <ValidationProvider
              v-slot="{ errors }"
              rules="required"
              name="employee_id"
            >
              <b-form-group
                label-for="employee_id"
                :state="errors[0] ? false : null"
              >
                <label class="form-label"
                  >{{ $t("Employee") }}
                  <span class="text-danger">(*)</span></label
                >
                <v-select
                  id="employee_id"
                  v-model="form.employee_id"
                  :options="employees"
                  :disabled="inputDisable || !form.area_id"
                  label="full_name"
                  placeholder="Seleccione..."
                  :reduce="(employee) => employee.id"
                  @input="changeEmploye"
                />
              </b-form-group>
            </ValidationProvider>
          </b-col>

          <!-- Cargo -->
          <b-col lg="4" md="12" sm="12">
            <b-form-group>
              <label for="cargo">Cargo</label>
              <b-form-input
                v-model="form.cargo"
                placeholder="Cargo..."
                disabled
              ></b-form-input>
            </b-form-group>
          </b-col>

          <!-- Fecha ultimo aumento -->
          <b-col lg="4" md="12" sm="12">
            <b-form-group label-for="fecha_aumento">
              <label for="fecha_aumento">Ultima fecha</label>
              <b-form-input
                id="fecha_aumento"
                v-model="form.fecha_aumento"
                placeholder="Fecha aumento..."
                disabled
              ></b-form-input>
            </b-form-group>
          </b-col>

          <!-- Sueldo actual -->
          <b-col lg="4" md="12" sm="12">
            <b-form-group label-for="sueldo_actual">
              <label for="sueldo_actual">Sueldo actual</label>
              <b-form-input
                id="sueldo_actual"
                v-model="form.sueldo_actual"
                placeholder="Sueldo actual..."
                disabled
              ></b-form-input>
            </b-form-group>
          </b-col>

          <!-- Bono actual -->
          <b-col lg="4" md="12" sm="12">
            <b-form-group label-for="bono_actual">
              <label for="bono_actual">Bono actual</label>
              <b-form-input
                id="bono_actual"
                v-model="form.bono_actual"
                placeholder="Bono actual..."
                disabled
              ></b-form-input>
            </b-form-group>
          </b-col>

          <!-- Sueldo base -->
          <b-col lg="4" md="12" sm="12">
            <b-form-group label-for="sueldo_base">
              <label for="sueldo_base"
                >Nuevo sueldo base <span class="text-danger">(*)</span></label
              >
              <money
                id="sueldo_base"
                v-model="form.sueldo_base"
                v-bind="{
                  decimal: '.',
                  thousands: ',',
                  prefix: prefix,
                  precision: 2,
                  masked: false,
                  max: 99999.99,
                }"
                class="form-control w-100 form-control-md"
              />
            </b-form-group>
          </b-col>

          <!-- Bonos -->
          <b-col lg="4" md="12" sm="12">
            <b-form-group label-for="Bonos">
              <label for="bonos">Nuevo bono</label>
              <money
                id="bonos"
                v-model="form.bonos"
                v-bind="{
                  decimal: '.',
                  thousands: ',',
                  prefix: prefix,
                  precision: 2,
                  masked: false,
                  max: 99999.99,
                }"
                class="form-control w-100 form-control-md"
              />
            </b-form-group>
          </b-col>

          <!-- Sueldo total -->
          <b-col lg="4" md="12" sm="12">
            <b-form-group label-for="sueldo_final">
              <label for="sueldo_final">Sueldo final</label>
              <!-- <money id="sueldo_final" v-model="form.sueldo_final" v-bind="{
                                decimal: '.',
                                thousands: ',',
                                prefix: prefix,
                                precision: 2,
                                masked: false,
                            }" class="form-control w-100 form-control-md" disabled /> -->
              <span
                class="form-control"
                :class="{ 'bg-dark': isDarkSkin, 'text-white': isDarkSkin }"
                >{{ getSueldototal }}</span
              >
            </b-form-group>
          </b-col>

          <!-- Fecha ultimo aumento -->
          <b-col lg="4" md="12" sm="12">
            <b-form-group label-for="fecha_vigencia">
              <label for="fecha_vigencia"
                >Fecha vigencia
                <feather-icon
                  icon="InfoIcon"
                  class="ml-05 text-warning"
                  v-b-tooltip.hover
                  title="Por defecto es el primer día del mes siguiente, pero puede ajustarse si rige a partir de otra fecha."
                ></feather-icon>
              </label>
              <kendo-datepicker
                class="w-100 rounded form-control-kendo"
                :class="[isDarkSkin ? ' bg-transparent' : '', '']"
                :min="minDate"
                :max="maxDate"
                v-model="form.fecha_vigencia"
                :format="'dd/MM/yyyy'"
                name="created_date"
                id="created_date"
                :disabled="modalData.action == 'revision'"
              ></kendo-datepicker>
            </b-form-group>
          </b-col>

          <!-- Motivo de solicitud -->
          <b-col
            md="12"
            lg="12"
            v-if="modalData.action == 'edit' || modalData.id == null"
          >
            <ValidationProvider
              v-slot="{ errors }"
              rules="required|max:200"
              name="motivo"
            >
              <b-form-group
                label-for="motivo"
                :state="errors[0] ? false : null"
              >
                <label for="motivo"
                  >Motivo de solicitud
                  <span class="text-danger">(*)</span></label
                >
                <b-form-input
                  id="motivo"
                  v-model="form.motivo"
                  placeholder="Motivo..."
                  maxlength="200"
                ></b-form-input>
              </b-form-group>
            </ValidationProvider>
          </b-col>

          <!-- Motivo de solicitud -->
          <b-col md="12" lg="12" v-if="modalData.action == 'revision'">
            <ValidationProvider
              v-slot="{ errors }"
              rules="required|max:200"
              name="motivo"
            >
              <b-form-group
                label-for="observacion_gerencia"
                :state="errors[0] ? false : null"
              >
                <label for="observacion_gerencia"
                  >Comentario <span class="text-danger">(*)</span></label
                >
                <b-form-input
                  id="observacion_gerencia"
                  v-model="form.observacion_gerencia"
                  placeholder="Comentario..."
                  maxlength="200"
                ></b-form-input>
              </b-form-group>
            </ValidationProvider>
          </b-col>
        </b-row>
      </ValidationObserver>
      <!-- </div> -->
      <div class="d-flex justify-content-end gap-x-3">
        <b-button
          v-if="modalData.id == null"
          @click="registrarAumento"
          variant="outline-success"
          >{{ $t("REGISTER") }}</b-button
        >
        <b-button
          v-if="modalData.action == 'revision'"
          variant="outline-primary"
          @click="revisarAumento('aprobado')"
          >APROBAR</b-button
        >
        <b-button
          v-if="modalData.action == 'revision'"
          variant="outline-danger"
          @click="revisarAumento('rechazado')"
          >RECHAZAR</b-button
        >
        <b-button
          v-if="modalData.action == 'edit'"
          variant="outline-warning"
          @click="actualizarAumento"
          >ACTUALIZAR</b-button
        >
      </div>
    </b-modal>
  </div>
</template>

<script>
import moment from "moment";
import flatPickr from "vue-flatpickr-component";
import { mapGetters } from "vuex";
import modalMixin from "@/mixins/modal";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import DiscountsService from "@/views/commons/discounts/services/discounts.service.js";
import AdelantoService from "@/views/rrhh/views/payroll/components/adelanto-sueldo/services/adelanto.sueldo.service.js";
import EmployeeService from "@/views/rrhh/views/employees/services/employee.service.js";

import AumentoSueldoService from "@/views/rrhh/views/aumento-sueldo/services/aumento-sueldo.service.js";
import { currencyFormat, CurrentFormat } from "@core/utils/filter";
import { parseDate } from "echarts/lib/util/number";

export default {
  mixins: [modalMixin],
  components: {
    flatPickr,
  },
  props: {
    modalData: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      form: {
        id: null,
        area_id: null,
        employee_id: null,
        cargo: "",
        sueldo_actual: 0,
        bono_actual: 0,
        fecha_aumento: "",
        fecha_vigencia: "",
        sueldo_base: 0,
        bonos: 0,
        sueldo_final: 0,
        motivo: null,
        observacion_gerencia: null,
      },
      disabled: false,
      approved: false,
      areas: [],
      employees: [],
      quotas: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      minDate: new Date(1000, 1, 1),
      maxDate: new Date(2050, 9, 1),
    };
  },
  mounted() {
    this.toggleModal("modal-rrhh-discount");
  },
  async created() {
    // this.form.fecha_vigencia = moment().format("DD/MM/YYYY");
    // primer dia del mes siguiente
    this.form.fecha_vigencia = moment()
      .add(1, "month")
      .startOf("month")
      .format("DD/MM/YYYY");

    try {
      this.addPreloader();

      const shouldFetchById = this.modalData.id != null;

      await this.getAreas();

      if (shouldFetchById) {
        this.form.id = this.modalData.id;

        await this.getAumentoById();
        await this.changeEmploye();
      }
    } catch (error) {
      console.log(error);
    } finally {
      this.removePreloader();
    }
  },

  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
    prefix() {
      return "S/.";
    },
    getSueldototal() {
      const sueldoBase = this.form.sueldo_base || 0;
      const bonos = this.form.bonos || 0;
      if (isNaN(sueldoBase) || isNaN(bonos)) {
        return currencyFormat(0);
      }
      return currencyFormat(parseFloat(sueldoBase) + parseFloat(bonos));
    },
    getTitleModal() {
      switch (this.modalData.action) {
        case "revision":
          return "REVISAR AUMENTO DE SUELDO";
        case "edit":
          return "EDITAR AUMENTO DE SUELDO";
        default:
          return "REGISTRAR AUMENTO DE SUELDO";
      }
    },
    inputDisable() {
      return (
        this.modalData.action == "revision" || this.modalData.action == "edit"
      );
    },
  },
  methods: {
    async getAumentoById() {
      try {
        const params = { id: this.modalData.id };

        const { data } = await AumentoSueldoService.show(params);
        // const { data } = await AdelantoService.show(params);
        console.log("data-aumento: ", data);
        if (data != null) {
          this.form.area_id = data.area_id;
          this.form.employee_id = data.id_empleado;
          this.form.fecha_vigencia = moment(
            data.fecha_vigencia,
            "YYYY-MM-DD"
          ).format("DD/MM/YYYY");
          this.form.sueldo_base = data.nuevo_sueldo_base;
          this.form.bonos = data.nuevo_bono;
          this.form.motivo = data.observacion;

          await this.getEmployeeByArea(data.id_empleado);
        }
      } catch (error) {
        console.log(error);
      } finally {
        // this.removePreloader();
      }
    },
    validarMontos(val) {
      console.log("validarMontos: ", val);
      const valor = parseFloat(this.form.bonos) || 0;
      if (valor > 99999.99) {
        this.form.bonos = 99999.99;
      }
    },
    async registrarAumento() {
      try {
        const result = await this.$refs[
          "ref-validation-aumento-sueldo"
        ].validate();
        if (result) {
          const confirm = await this.showConfirmSwal();
          if (confirm.isConfirmed) {
            this.addPreloader();
            this.form.user_id = this.currentUser.id;

            const { data } = await AumentoSueldoService.store(this.form);

            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: this.$t(data.message),
                icon: "CoffeeIcon",
                variant: "success",
                text: this.$t(data.message),
              },
            });
            this.$emit("updated");
          }
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Error",
            icon: "CoffeeIcon",
            variant: "danger",
            text: "Error al registrar el aumento de sueldo",
          },
        });
      } finally {
        this.removePreloader();
      }
    },
    async revisarAumento(action) {
      try {
        const result = await this.$refs[
          "ref-validation-aumento-sueldo"
        ].validate();
        if (result) {
          const confirm = await this.showConfirmSwal();

          if (confirm.isConfirmed) {
            this.form.user_id = this.currentUser.id;

            this.addPreloader();
            const { data } = await AumentoSueldoService.updateStatus({
              id: this.form.id,
              estado: action,
              nuevo_sueldo_base: this.form.sueldo_base,
              nuevo_bono: this.form.bonos,
              observacion_gerencia: this.form.observacion_gerencia,
            });

            console.log("estaod: ", data);
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: this.$t(data.message),
                icon: "CoffeeIcon",
                variant: "success",
                text: this.$t(data.message),
              },
            });
            this.$emit("updated");
          }
        }
      } catch (error) {
        console.log(error);
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Error",
            icon: "CoffeeIcon",
            variant: "danger",
            text: "Erorr al revisar el aumento de sueldo",
          },
        });
      } finally {
        this.removePreloader();
      }
    },
    async actualizarAumento() {
      try {
        const result = await this.$refs[
          "ref-validation-aumento-sueldo"
        ].validate();
        if (result) {
          const confirm = await this.showConfirmSwal();
          if (confirm.isConfirmed) {
            this.addPreloader();

            const { data } = await AumentoSueldoService.update(this.form);

            console.log("repsonse: ", data);
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: this.$t(data.message),
                icon: "CoffeeIcon",
                variant: "success",
                text: this.$t(data.message),
              },
            });
            this.$emit("hideModal", true);
          }
        }
      } catch (error) {
        console.log(error);
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Error",
            icon: "CoffeeIcon",
            variant: "danger",
            text: "Ocurrio un error al actualizar el aumento de sueldo",
          },
        });
      } finally {
        this.removePreloader();
      }
    },
    async getAreas() {
      try {
        // this.addPreloader();
        const { data } = await EmployeeService.getAllAreas({
          moduleId: this.currentUser.modul_id,
        });
        this.areas = data;
      } catch (error) {
        console.log(error);
      } finally {
        // this.removePreloader();
      }
    },
    async getEmployeeByArea(employee_id = null) {
      if (employee_id == null) {
        this.form.employee_id = null;
      } else {
        this.form.employee_id = employee_id;
      }
      try {
        this.addPreloader();
        // this.addPreloader();
        const params = {
          area_id: this.form.area_id,
        };
        const { data } = await DiscountsService.getEmployeeByArea(params);
        this.employees = data;
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },

    async changeEmploye() {
      if (this.form.employee_id != null) {
        try {
          this.addPreloader();
          const { data } =
            await AumentoSueldoService.getInfoSalarialEmpleadoById(
              this.form.employee_id
            );
          this.form.cargo = data.cargo;
          this.form.sueldo_actual = data.sueldo_actual;
          this.form.bono_actual = data.bonos;
          this.form.fecha_aumento = moment(
            data.fecha_aumento,
            "YYYY-MM-DD"
          ).format("DD/MM/YYYY");

          if (this.modalData.id == null) {
            console.log("ingresa..");
            this.form.sueldo_base = data.sueldo_actual;
            this.form.bonos = data.bonos;
          }
        } catch (error) {
          console.log(error);
        } finally {
          this.removePreloader();
        }
        return;
      }

      this.form.cargo = null;
      this.form.sueldo_actual = 0;
      this.form.fecha_aumento = null;
      this.form.bonos = 0;
    },

    calcularSueldoFinal() {
      this.form.sueldo_final =
        parseFloat(this.form.sueldo_base) + parseFloat(this.form.bonos);
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>